import React, { useMemo } from "react";
import { TransactionFiltersDto } from "@common/dto/transactions/getTransactions/transaction-filters.dto";
import { pluralizeWithCount } from "@common/helpers/string";
import { Button } from "@design-system/Button/Button";
import { useEntities } from "@hooks/useEntities";
import { ExcludeEmptyMockEntitiesMode } from "@hooks/useEntitiesContexts";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import styles from "./SimilarTransactionsUpdateDrawer.module.scss";

interface Props {
    filters: Pick<TransactionFiltersDto, "entityIds">;
}

export const SimilarTransactionsEntityFilter: React.FC<Props> = ({
    filters,
}) => {
    const entities = useEntities({
        excludeEmptyMockEntities:
            ExcludeEmptyMockEntitiesMode.REQUIRE_TRANSACTIONS,
    });

    const selectedEntities = useMemo(() => {
        const entityIds = filters.entityIds ?? [];

        if (entityIds.length === 0) {
            return [];
        }

        return entities.filter((entity) => entityIds.includes(entity.id));
    }, [entities, filters.entityIds]);

    if (selectedEntities.length === 0) {
        return null;
    }

    return (
        <Button
            variant="primary"
            size="md"
            type="button"
            tabIndex={-1}
            aria-disabled
            className={styles.readOnlyEntityFilter}
        >
            <EntityAvatarGroup
                entities={selectedEntities}
                max={3}
                label={pluralizeWithCount("Entity", selectedEntities.length)}
            />
        </Button>
    );
};
